export default "__VITE_ASSET__Cx9aj6Rn__"